export default {"src":"/_next/static/media/homescreen_creditscore_img.d439e72b.svg","height":200,"width":650,"blurWidth":0,"blurHeight":0};